export enum AccountStatementOption {
  SEND = 'send', // option send invoice by email
  PRINT = 'print',
}
